export default {
    product: state => state.products
}